var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    className: "svg-opacity"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0383 1.95307H12.6613V0.25293H11.3426V1.95307H7.96558V3.83502H16.0383V1.95307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0082 21.4395V6.15381C18.0082 5.60152 17.5605 5.15381 17.0082 5.15381H6.99547C6.44319 5.15381 5.99547 5.60152 5.99547 6.15381V21.4395H3.00366V22.7581H21V21.4395H18.0082ZM11.2629 6.80745H12.7408V8.1261H11.2629V6.80745ZM11.2629 9.7797H12.7408V11.0984H11.2629V9.7797ZM11.2629 12.752H12.7408V14.0706H11.2629V12.752ZM7.55294 6.80745H9.0308V8.1261H7.55294V6.80745ZM7.55294 9.7797H9.0308V11.0984H7.55294V9.7797ZM7.55294 12.752H9.0308V14.0706H7.55294V12.752ZM16.3711 21.4395H15.0525V17.1985H12.6611V21.4395H11.3425V17.1985H8.95115V21.4395H7.6325V15.8798H16.3711V21.4395ZM16.4507 14.0706H14.9729V12.752H16.4507V14.0706ZM16.4507 11.0984H14.9729V9.7797H16.4507V11.0984ZM16.4507 8.1261H14.9729V6.80745H16.4507V8.1261Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.c853b18b.svg";
export { ForwardRef as ReactComponent };